import { combineReducers } from "redux"
import { appReducer as app } from "./reducers/app.reducer";

const reducer = combineReducers({
    app
})

export default reducer

export type State = ReturnType<typeof reducer>